import { render, staticRenderFns } from "./Oils.vue?vue&type=template&id=36d459ae"
import script from "./Oils.vue?vue&type=script&lang=js"
export * from "./Oils.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports